import { useEffect } from 'react';

const useOutsideClick = (refs, handler, disabled = false) => {
  useEffect(() => {
    const listener = event => {
      const exist = refs.find(ref => {
        return !ref.current || ref.current.contains(event.target) || disabled;
      });

      if (exist) return;
      handler(event);
    };

    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
    //eslint-disable-next-line
  }, [refs, handler]);
};

export default useOutsideClick;
